/*
 * Sooma smooth accordion
 * Progressive enhancement for <details class="sooma-faq"> elements.
 * - Animates open/close height (classic smooth dropdown)
 * - Only one open at a time within the same parent container
 * - Falls back to plain native <details> if JS is off
 * Reuse on any section: wrap each item as
 *   <details class="sooma-faq"><summary>…</summary><div class="sooma-faq__a">…</div></details>
 */
(function () {
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onEnd(el, fn) {
    var done = false;
    function handler(e) {
      if (e && e.target !== el) return;
      if (done) return;
      done = true;
      el.removeEventListener('transitionend', handler);
      fn();
    }
    el.addEventListener('transitionend', handler);
    setTimeout(function () { handler(); }, 420);
  }

  function close(d) {
    var c = d.querySelector('.sooma-faq__a');
    if (REDUCED || !c) { d.open = false; return; }
    c.style.height = c.scrollHeight + 'px';
    requestAnimationFrame(function () { c.style.height = '0px'; });
    onEnd(c, function () { d.open = false; c.style.height = ''; });
  }

  function open(d) {
    var c = d.querySelector('.sooma-faq__a');
    d.open = true;
    if (REDUCED || !c) return;
    c.style.height = '0px';
    requestAnimationFrame(function () { c.style.height = c.scrollHeight + 'px'; });
    onEnd(c, function () { c.style.height = 'auto'; });
  }

  function bind(d) {
    if (d.dataset.accInit) return;
    d.dataset.accInit = '1';
    var summary = d.querySelector('summary');
    if (!summary) return;
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (d.open) {
        close(d);
      } else {
        var siblings = d.parentElement.querySelectorAll(':scope > details.sooma-faq');
        siblings.forEach(function (o) { if (o !== d && o.open) close(o); });
        open(d);
      }
    });
  }

  function init(root) {
    (root || document).querySelectorAll('details.sooma-faq').forEach(bind);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  // Re-init when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
